import { createRequestTypes, action } from 'redux-config/reduxHelpers';

export const GET_ACTIVE_ANNOUNCEMENT = createRequestTypes('GET_ACTIVE_ANNOUNCEMENT');

export const getActiveAnnouncement = {
  request: () => action(GET_ACTIVE_ANNOUNCEMENT.REQUEST),
  success: data => action(GET_ACTIVE_ANNOUNCEMENT.SUCCESS, { data }),
  failure: error => action(GET_ACTIVE_ANNOUNCEMENT.FAILURE, { error }),
};
